//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- Start
import { useCallback, useEffect, useMemo, useState } from 'react';
import { BzButton, BzCard, BzInputText } from '../../../../../components';
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import {
    getAppInfoData, getDyanmicURL, getFixedFloatedValue, getFormattedNumbers, getSummaryData,
    onTouchLineSubscriptionForPortfolioSummary, updateHoldingData,setStorageWithMultiTabCheckWithoutEncryption
} from '../../../../../utils/global_functions';
import { useWFHMessages } from '../../../../../hooks';
import { getWfhTouchlineLastTick } from '../../../../../redux/actions/wfh';
import { sendTouchlineRequest } from '../../../../../apis/web_socket';
import { APP_AVG_BUY_PRICE, APP_INFO_DEFAULT_VALUES, APP_INFO_PARAMS, LINK_OPEN_MODES, MARKET_SEGMENT_ID, ORDER_TYPES, SESSION_STORAGE_KEYS, WATCHLIST_GRID_INDEX ,MAPPED_MARKET_SEGMENT_ID} from '../../../../../utils/global_variables';
import { Link, useNavigate } from 'react-router-dom';
import { handleModal, handleModalData } from '../../../../../redux/actions/modals';
import { getAllHoldingScrips } from '../../../../../redux/actions/holdings';
import ZeroStates from '../../../../ZeroStates';
import { _holdingsFilters } from '../../../../../controllers/holdings';
import { getScripOrderInfo, updateFilters } from '../../../../../redux/actions/orders';
import { updateInAppIFrame } from '../../../../../redux/actions/appInfo';

let nFormat = 2;
let temp = {
    currentValue: 0, investedValue: 0, overAllPL: 0, todaysPL: 0, prevCloseValue: 0, todaysPLPer: 0, PLPer: 0
};

const Equity = () => {


    const zeroVal = 0;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const holdingsScrips = useSelector(state => state.holdings.holdingsScrips);
    const appInfo = useSelector(state => state.appInfo.appInfo);
    const dontMissData = useSelector(state => state.dontMiss.dontMissData);
    const modalData = useSelector(state => state.modals?.modalData);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const objFilterData = useSelector(state => state?.orders?.objFilterData);

    const [searchText, setSearchText] = useState();
    const [isSearchShoing, setIsSearchShowing] = useState(true);
    const [summaryData, setSummaryData] = useState(temp);
    const [arrHoldings, setArrHoldings] = useState([]);


    useEffect(() => {
        setArrHoldings(holdingsScrips);
    }, [holdingsScrips?.length]);


    const isInvestedOverallPLVisible = useMemo(() => {
        const isVisible = getAppInfoData(APP_INFO_PARAMS.APP_AVG_BUY_PRICE, APP_AVG_BUY_PRICE.OFF);
        if (isVisible === APP_AVG_BUY_PRICE.OFF) {
            return true;
        } else if (isVisible === APP_AVG_BUY_PRICE.ON) {
            return false;
        }
    }, [appInfo]);

    const objHoldingScrips = useMemo(() => {
        let obj = {};
        if (holdingsScrips?.length) {
            holdingsScrips?.forEach(holdingDataItem => {
                holdingDataItem.ISIN = holdingDataItem.ISIN.trim();
                holdingDataItem.ltp = 0.00;
                holdingDataItem.ltpDisplay = "0.00";
                holdingDataItem.closePrice = 0.00;
                holdingDataItem.PandL = 0.00;
                holdingDataItem.TodaysPandL = 0.00;
                holdingDataItem.CMV = 0.00;
                holdingDataItem.PrevCloseValue = 0.00;
                holdingDataItem.InvestedValue = (holdingDataItem.nBuyAvgPrice && holdingDataItem.nNormal_MarketAllowed === 1) ? (parseFloat(holdingDataItem.nBuyAvgPrice) * parseInt(holdingDataItem.TOTALFREEQUANTITY)).toFixed(2) : 0.00; //Vaibhav Singh:23-02-24 Updated changes for key as in wave: Start
                holdingDataItem.InvestedValueDisplay = getFormattedNumbers(holdingDataItem.InvestedValue);
                holdingDataItem.nBuyAvgPriceDisplay = getFormattedNumbers(holdingDataItem.nBuyAvgPrice);
                holdingDataItem.perPandL = 0.00;
                holdingDataItem.perTodaysPandL = 0.00;
                holdingDataItem.NetChangeInRs = 0.00;
                holdingDataItem.PercNetChange = 0.00;
                holdingDataItem.LTPTrend = '';
                holdingDataItem.arrowTrend = '';

                temp.investedValue = getFixedFloatedValue(parseFloat(temp?.investedValue) + parseFloat(holdingDataItem?.InvestedValue || 0), nFormat);
                const key = `${holdingDataItem?.nMarketSegmentId}_${holdingDataItem?.nToken}`;
                obj[`${key}`] = holdingDataItem;
            });
        }
        return obj;
    }, [holdingsScrips?.length]);

    const receiveTouchLine = useCallback((objMultiTLResp) => {

        if (objMultiTLResp != null || objMultiTLResp !== undefined) {
            objMultiTLResp.PriceFormat = objMultiTLResp?.PriceFormat || nFormat;
            objMultiTLResp.ClosePrice = objMultiTLResp?.ClosePrice || zeroVal.toFixed(objMultiTLResp?.PriceFormat);
            objMultiTLResp.LTP = objMultiTLResp?.LTP || zeroVal.toFixed(objMultiTLResp?.PriceFormat);

            if (Object?.keys(objHoldingScrips)?.length) {
                const key = `${objMultiTLResp?.Scrip._MktSegId}_${objMultiTLResp?.Scrip.token}`;
                const holdingDataItem = objHoldingScrips[key];

                if (holdingDataItem) {
                    const holdingDataItemOld = {
                        CMV: holdingDataItem?.CMV,
                        TodaysPandL: holdingDataItem?.TodaysPandL,
                        PrevCloseValue: holdingDataItem?.PrevCloseValue,
                    };

                    nFormat = objMultiTLResp?.PriceFormat;
                    objMultiTLResp.LTP = (parseFloat(objMultiTLResp?.LTP) === 0 ? objMultiTLResp?.ClosePrice : objMultiTLResp?.LTP);

                    //Updates scrips data
                    const updatedHoldingItem = updateHoldingData(holdingDataItem, objMultiTLResp, nFormat, zeroVal);
                    objHoldingScrips[`${objMultiTLResp?.Scrip._MktSegId}_${objMultiTLResp?.Scrip.token}`] = updatedHoldingItem;
                    //     objHoldingScrips = { ...objHoldingScrips,`${objMultiTLResp?.Scrip._MktSegId}_${objMultiTLResp?.Scrip.token}`: updatedHoldingItem
                    // }
                    //  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings :Start
                    const calcMethod = holdingsScrips?.length === 1 ? false : true;

                    temp = getSummaryData(updatedHoldingItem, holdingDataItemOld, temp, true, zeroVal, nFormat, calcMethod);
                    //  Vaibhav S:22-02-2024:BT-102298:BSEEQ Holdings :End
                    setSummaryData({ ...temp });
                }
                else { }
            }
            else { }
        } else { }
    }, [objHoldingScrips]);

    useEffect(() => {
        // Dont put !holdingsScrips.length it will make infinite API request
        if (holdingsScrips == null) {
            dispatch(getAllHoldingScrips());
        } else { }
    }, [dispatch, holdingsScrips]);

    useEffect(() => {
        return () => {
            temp = {
                currentValue: 0, investedValue: 0, overAllPL: 0, todaysPL: 0, prevCloseValue: 0, todaysPLPer: 0, PLPer: 0
            };
        };
    }, []);

    useWFHMessages('touchline', (e) => {
        const arrTouchLineData = e.detail;

        const obj = onTouchLineSubscriptionForPortfolioSummary(arrTouchLineData, holdingsScrips, zeroVal, nFormat, temp, dispatch);
        if (obj !== undefined) {
            receiveTouchLine(obj);
        }
    });

    useEffect(() => {
        if (holdingsScrips?.length > 0) {
            const objTouchlineData = dispatch(getWfhTouchlineLastTick());
            const arrSubscriptionScrips = holdingsScrips?.map(scrip => {

                const arrLastTickScripData = objTouchlineData[scrip?.nMarketSegmentId + '_' + scrip?.nToken];

                if (arrLastTickScripData?.length) {
                    const obj = onTouchLineSubscriptionForPortfolioSummary(arrLastTickScripData, holdingsScrips, zeroVal, nFormat, temp, dispatch);
                    if (obj !== undefined) {
                        receiveTouchLine(obj);
                    }
                }
                return { exchangeId: scrip.nMarketSegmentId, token: scrip.nToken };
            });
            if (arrSubscriptionScrips?.length) {
                sendTouchlineRequest(arrSubscriptionScrips);
            }
        }
        else { }
        return () => {
            if (holdingsScrips?.length > 0) {
                const arrSubscriptionScrips = holdingsScrips?.map(scrip => {
                    return { exchangeId: scrip.nMarketSegmentId, token: scrip.nToken, isSubscribe: false };
                });
                if (arrSubscriptionScrips?.length) {
                    sendTouchlineRequest(arrSubscriptionScrips);
                }
            }
        };
    }, [dispatch, holdingsScrips, receiveTouchLine]);

    const onSearchChange = (value) => {
        setSearchText(value);
    };

    const onSearchClose = () => {
        setSearchText();
        setIsSearchShowing(true);
    };

    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -start
    const portfolioAnalyzerInfo = useMemo(() => {
        const analyzerData = getAppInfoData(APP_INFO_PARAMS.APP_PORTFOLIO_ANALYZER, APP_INFO_DEFAULT_VALUES.PORTFOLIO_ANALYZER_DATA);
        return analyzerData ;
    }, [appInfo]);

    const handlePortfolioAnalyser = () => {
        const URL = getDyanmicURL({ url: portfolioAnalyzerInfo?.url }, objLoginSession);
        if (URL) {
            if (portfolioAnalyzerInfo?.openmode === LINK_OPEN_MODES.IFRAME) {
                dispatch(updateInAppIFrame({ url: URL, title: portfolioAnalyzerInfo?.title }));
                dispatch(handleModal([{ "IN_APP_IFRAME": true }]));
            }
            else {
                window.open(portfolioAnalyzerInfo?.url);
            }
        } else { }
    };
    const filteredData = useMemo(() => {
        if (modalData?.filter !== undefined) {
            if (Object?.keys(modalData?.filter)?.length > 0) {
                const filteredArray = _holdingsFilters(modalData?.filter, arrHoldings);
                return filteredArray;
            } else { }
        } else { }
        if (arrHoldings?.length > 0) {
            if (searchText?.length > 0) {
                const filteredPositions = arrHoldings?.filter((each) => each.sSymbol.toLowerCase().includes(searchText.toLowerCase()));
                return filteredPositions;
            } else {
                return arrHoldings;
            }
        } else { }
    }, [searchText, modalData, arrHoldings, objHoldingScrips]);

    const handlePlaceOrder = () => {
        dispatch(handleModal([{ "ORDER_ENTRY_MODAL": true }]));
        dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.SINGLE_SCRIP } }));
        const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: [] };
        dispatch(getScripOrderInfo(objScrpinfo));
    };
    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -end


    //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : Start
    const handleFilters = () => {
        if (arrHoldings?.length) {
            dispatch(handleModal([{ "FILTER_ORDER_POSITION_MODAL": true }]));
            dispatch(handleModalData({ data: arrHoldings, type: 'Holdings' }));
        }
    };

    const handleOrderHistory = (id) => {
        const path = `/portfolio?section=holdings`;
        navigate(path, { state: id });
        setStorageWithMultiTabCheckWithoutEncryption(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
    };
    const handleClickChips = (ele) => {
        delete objFilterData[ele];
        dispatch(handleModalData({ filter: objFilterData }));
        dispatch(updateFilters(objFilterData));
    };
    return (
        <>
            <Container fluid className='p-0 px-3'>
                <Row className='g-0 py-1 mb-2 align-items-center h_40'>
                    <Col md={3} className='d-flex justify-content-start align-items-center'>&nbsp;</Col>
                    <Col md={9} className='d-flex justify-content-end align-items-center'>
                        {isSearchShoing === true ?
                            <div onClick={() => setIsSearchShowing(arrHoldings?.length ? false : true)} className={`icon-16 icon-search ${arrHoldings?.length ? 'icon-dark' : 'icon-grey'}`}></div>
                            : <>
                                <div className='position-relative w-70'>
                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                    <BzInputText autoFocus onChange={(e) => onSearchChange(e.target.value)} size='sm' type='search' placeholder="search here" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                                </div>
                                <div className='icon-16 icon-dark icon-close ms-2' onClick={() => onSearchClose()} />
                            </>
                        }
                        <div className={`icon-16 icon-searchfilter ${arrHoldings?.length ? 'icon-dark' : 'icon-grey'} ms-3`} onClick={handleFilters}></div>
                        <Link to='/portfolio?section=holdings'>
                            <div className='icon-14 icon-redirect icon-dark ms-3'></div>
                        </Link>
                    </Col>
                </Row>
                {Object.keys(objFilterData)?.length ?
                    <Row className='g-0 mb-3'>
                        <Col className='d-flex'>
                            <div className='font-medium font-size3 color-text m-1'>Filters:</div>
                            <div className='horizontal-scroll-wrap filters-chips-wrap flex-nowrap'>
                                {Object.keys(objFilterData)?.map((ele, i) => {
                                    return <div key={i} className='chips chips default-chip text-capitalize m-1'>
                                        {objFilterData[ele] === "low_high" ? `${ele} : Low-High` : objFilterData[ele] === "high_low" ? `${ele} : High-Low` : parseFloat(objFilterData[ele]) ? `${ele.slice(-3)} : ${objFilterData[ele]}` : `${ele} : ${objFilterData[ele]}`} <div style={{ width: "6px", height: '6px', marginLeft: "6px" }} onClick={handleClickChips?.bind(this, ele)} className='icon-16 icon-dark icon-close'></div>
                                    </div>;
                                })
                                }
                            </div>
                        </Col>
                    </Row>
                    : null
                }
                {/* Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : End */}
            </Container>
            {arrHoldings?.length > 0 ?
                <Container fluid className='p-0'>
                    <div className='sticky-orderpositions-height px-3'>
                        <Row className='g-0 order-position-card-wrapper p-3 mb-3'>
                            <Row className='g-0 mb-3'>
                                <Col>
                                    <div className='font-regular font-size2 color-subtext text-capitalize'>Current Value</div>
                                    <div className='font-medium font-size4 color-text'>&#8377;{getFormattedNumbers(summaryData?.currentValue)}</div>
                                </Col>
                                {isInvestedOverallPLVisible &&
                                    <Col className='text-end'>
                                        <div className='font-regular font-size2 color-subtext text-capitalize'>Invested Value</div>
                                        <div className='font-medium font-size4 color-text'>&#8377;{getFormattedNumbers(summaryData?.investedValue)}</div>
                                    </Col>
                                }
                            </Row>

                            <Row className='g-0 mb-3'>
                                {isInvestedOverallPLVisible &&
                                    <Col>
                                        <div className='font-regular font-size2 color-subtext text-capitalize'>Overall P/L</div>
                                        <div className={`font-medium font-size3 color-text ${summaryData?.overAllPL > 0 ? 'color-positive' : 'color-negative'}`}>&#8377;{getFormattedNumbers(summaryData?.overAllPL)}
                                            {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA  Todays and OverAll P/l % removed -Start
                                         Dont remove code it may be require later  */}
                                            {/* ( {getFormattedNumbers(summaryData?.PLPer)} %) */}
                                            {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA  Todays and OverAll P/l % removed -End */}
                                        </div>
                                    </Col>
                                }
                                <Col className='text-end'>
                                    <div className='font-regular font-size2 color-subtext text-capitalize'>Today's P/L</div>
                                    <div className={`font-medium font-size3 color-text ${summaryData?.todaysPL > 0 ? 'color-positive' : 'color-negative'}`}>&#8377;{getFormattedNumbers(summaryData?.todaysPL)}
                                        {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA  Todays and OverAll P/l % removed -Start
                                         Dont remove code it may be require later  */}
                                        {/* ( {getFormattedNumbers(summaryData?.todaysPLPer)} % ) */}
                                        {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA  Todays and OverAll P/l % removed -End */}
                                    </div>
                                </Col>
                            </Row>
                            <div>
                                {
                                    portfolioAnalyzerInfo && portfolioAnalyzerInfo?.url &&
                                    <Row className='g-0'>
                                        <Col className='d-flex justify-content-center'>
                                            <BzButton className='btn btn-md btn-primary' onClick={handlePortfolioAnalyser}>{portfolioAnalyzerInfo?.title}</BzButton>
                                        </Col>
                                    </Row>
                                }
                            </div>
                        </Row>
                        <Row className='g-0'>
                            <Col>
                                <div className='p-0'>
                                    <div className='transparent-card-wrap'>
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - Start*/}
                                        {filteredData?.length > 0 ? filteredData?.map((each, i) => (
                                            <>
                                                <BzCard key={i} className='transparent-card cursor-pointer bdr-btm' onClick={() => handleOrderHistory(each?.segmentIdToken)}>
                                                    <Row className='g-0 mb-1'>
                                                        <Col className='d-flex justify-content-start align-items-center'>
                                                            <div className='font-medium font-size3 color-text text-uppercase me-2'>{each?.sSymbol}</div>

                                                            <div className='d-flex justify-content-start align-items-center'>
                                                                <div className='font-regular font-size3 color-subtext text-uppercase me-2'>{each?.sSeries} </div>
                                                                {dontMissData?.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === each?.nMarketSegmentId + '_' + each?.nToken)
                                                                    ?
                                                                    <div className='icon-14 icon-dontmiss icon-yellow float-start me-2'></div> : null}
                                                            </div>
                                                        </Col>
                                                        <Col md={6} className='d-flex justify-content-end align-self-center'>
                                                            <div className='font-regular font-size2 color-text text-end'>
                                                                <span className='color-subtext'>P/L: </span>
                                                                <span className={`${parseFloat(each?.TodaysPandL) === 0 ? 'color-text' : parseFloat(each?.TodaysPandL) > 0 ? 'color-positive' : 'color-negative'}`}>{parseFloat(each?.TodaysPandL) > 0 ? '+' : ''}{parseFloat(each?.TodaysPandL).toFixed(each?.nMarketSegmentId == MAPPED_MARKET_SEGMENT_ID.MAPPED_NSX_DERIVATIVES ? 4 : 2)}(<span>{parseFloat(each?.perTodaysPandL) > 0 ? '+' : ''}{parseFloat(each?.perTodaysPandL).toFixed(2)}</span>%)</span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0 mb-1'>
                                                        <Col className='d-flex justify-content-start align-self-center'>
                                                            <div className='font-regular font-size2 color-text'>
                                                                <span className='color-subtext'>Qty: </span>{each?.TOTALFREEQUANTITY} @ Avg. {each?.nBuyAvgPriceDisplay}</div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0'>
                                                        <Col className='d-flex justify-content-start align-self-center'>
                                                            <div className='font-regular font-size2 color-text text-end'>
                                                                <span className='color-subtext'>LTP: </span>{each?.ltp}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </BzCard>
                                            </>
                                        )) :
                                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                                <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                                <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                                <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                            </div>
                                        }
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - End*/}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
                :
                <div className='zero-state-alerts zero-state-alerts-lg'>
                    <ZeroStates handleOnClick={handlePlaceOrder} subTextClass="font-regular font-size3 color-text" subText="Your holdings seems empty" icon='icon-64 icon-nodata mb-3 mrgauto' />
                    <div className='font-regular font-size2 color-nodata'>Place an order today</div>
                </div>
            }
        </>
    );
};

export default Equity;

//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- End
